<template>
  <router-view />
</template>

<script>
export default {
  name: 'AlertWrapper',
  created() {},
  destroyed() {},
};
</script>
